import { makeStyles } from '@material-ui/core/styles'

export const textStyles = makeStyles((theme) => ({
    primaryWhite: {
        color: 'white'
    },
    divider: {
        margin: '8px auto',
        background: '#808080',
        maxWidth: 60,
        opacity: 0.4
    },
    container: {
        margin: '20px 0px',
        maxWidth: 1000,
        fontFamily: 'Encode Sans',

        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center'
    },
    title: {
        fontWeight: 300,
        fontSize: 28,
        fontFamily: 'Encode Sans',

        textTransform: 'uppercase',
        color: '#33949E',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: 22,

        },
    },
    subTitle: {
        fontWeight: 300,
        textTransform: 'uppercase',
        color: '#33949E',
        textAlign: 'center',
        fontFamily: 'Encode Sans',

    },
    lostText: {
        color: 'white',
        textAlign: 'center',
        fontFamily: 'Encode Sans',

    },
    logo: {
        fontSize: 26,
        textTransform: 'capitalize',
        fontFamily: 'Encode Sans',
        fontWeight: 600,
        cursor: 'pointer'
    },
    escapeRoomTittle: {
        color: 'black',
        borderColor: 'white',
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        padding: '16px 80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 30,
        borderStyle: 'solid',
        marginLeft: 15
    },
    eTitle: {
        color: 'black',
        borderColor: 'white',
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        padding: '16px 80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 30,
        borderStyle: 'solid',
        marginLeft: 15
    },
    chooseTask: {
        extAlign: 'center',
        color: 'white',
        fontWeight: 500,
        margin: 0,
        paddingTop: 8,
        backgroundColor: '#33949E'
    },
    timeSpan: {
        padding: 10,
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontSize: 12
    },
    puzzleName: {
        padding: 10,
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    puzzleIndex: {
        textAlign: 'center',
        color: 'white',
        fontWeight: 500,
        margin: 0,
        paddingTop: 8
    }
}))
